import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class TransactionTimelinesModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            isDelete: false,
            transactionTimeline: props.isNew ? {} : props.transactionTimeline,
            disputeRegions: [],
            disputeCategories: [],
            disputeRegion: null,
            disputeCategory: null,
            title: props.isNew ? "New Transaction Timeline" : `Transaction Timeline`,
            updating: false,
            touchedForm: false,
            disputeRegionValidity: -1,
            disputeCategoryValidity: -1,
            validTimeValidity: -1,
            waitTimeValidity: -1

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onDisputeRegionChange = this.onDisputeRegionChange.bind(this);
        this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
    }

    onTextInputChange(evt) {

        let transactionTimeline = Object.assign({}, this.state.transactionTimeline);
        transactionTimeline[evt.target.id] = evt.target.value || null;

        let stateUpdate = {
            transactionTimeline,
            touchedForm: true,
        }
        stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;

        this.setState(stateUpdate);
    }
    onDisputeRegionChange(evt) {
        let transactionTimeline = Object.assign({}, this.state.transactionTimeline);
        transactionTimeline.disputeRegion = evt ? evt.value : null;

        this.setState({
            transactionTimeline,
            disputeRegion: evt,
            touchedForm: true,
            disputeRegionValidity: evt ? 1 : 0

        });
    }

    onDisputeCategoryChange(evt) {
        let transactionTimeline = Object.assign({}, this.state.transactionTimeline);
        transactionTimeline.disputeCategory = evt ? evt.value : null;
        this.setState({
            transactionTimeline,
            disputeCategory: evt,
            touchedForm: true,
            disputeCategoryValidity: evt ? 1 : 0
        });
    }

    componentDidMount() {

        //Get Dispute Regions
        ArbiterApi.getDisputeRegions()
            .then(response => {

                let disputeRegions = response.data.content.map(obj => {

                    obj.label = obj.name;
                    obj.value = obj.name;
                    return obj;
                });

                this.setState({ disputeRegions });
            })
            .catch(error => {
                Util.errorMessageToast(Toaster, error.data,
                        [` ${Messages.ERROR_DISPUTE_REGION}`] 
                );
                console.log(error);
            })

             //Get Dispute Categories
        ArbiterApi.getDisputeCategories()
        .then(response => {

            let disputeCategories = response.data.map(obj => {

                obj.label = obj.category;
                obj.value = obj.category;
                obj.statuses = obj.statuses.map(status => {
                    return {
                        label: status,
                        value: status,
                    }
                })
                return obj;
            });

            this.setState({ disputeCategories });
        })
        .catch(error => {
            Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_DISPUTE_CATEGORIES}`, '']);
            console.log(error);
        })

    }

    

    handleAction(evt) {
        this.setState({ updating: true });

        const transactionTimeline = this.state.transactionTimeline;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createTransactionTimeline(transactionTimeline) : ArbiterApi.updateTransactionTimeline(transactionTimeline.id, transactionTimeline)
        promise.then((response) => {
            Toaster.success(`Transaction Timeline  successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                Util.errorMessageToast(Toaster,error.data,[`${error.data ? error.data.description : error.statusText}`,`${Messages.ERROR_TRANSACTION_TIMELINES_UPDATE} `]);
                this.setState({ updating: false });
            })
    }

    handleDeleteAction(evt) {
        this.setState({ updating: true });
        const transactionTimeline = this.state.transactionTimeline;
        ArbiterApi.deleteTransactionTimeline(transactionTimeline.id)
            .then((response) => {
                Toaster.success(Messages.SUCCESS_TRANSACTION_TIMELINE_DELETE);
                this.setState({ updating: false });
                this.props.onRequestClose(evt, true);
            })
            .catch((error) => {
                Util.errorMessageToast(Toaster,error.data,[`${error.data ? error.data.description : error.statusText}`,`${Messages.ERROR_TRANSACTION_TIMELINES_DELETE} `]);
                this.setState({ updating: false });
            });
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        const isDelete = this.state.isDelete;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Dispute Region</label>
                                        <label>{this.state.transactionTimeline.disputeRegion}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Dispute Category</label>
                                        <label>{this.state.transactionTimeline.disputeCategory}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Wait Time</label>
                                        <label>{this.state.transactionTimeline.waitTime}</label>
                                    </div>

                                    <div className="form-div">
                                        <label>Valid Time</label>
                                        <label>{this.state.transactionTimeline.validTime}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label className="required">Dispute Region</label>
                                        <Select
                                            id="disputeRegion"
                                            value={this.state.transactionTimeline.disputeRegion}
                                            options={this.state.disputeRegions}
                                            onChange={this.onDisputeRegionChange}
                                            placeholder="Select Dispute Region"
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label className="required">Dispute Category</label>
                                        <Select
                                            id="disputeCategory"
                                            value={this.state.transactionTimeline.disputeCategory}
                                            options={this.state.disputeCategories}
                                            onChange={this.onDisputeCategoryChange}
                                            placeholder="Select Dispute Category"
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label className="required">Wait Time (in hours)</label>
                                        <FloatInput
                                            id="waitTime"
                                            value={this.state.transactionTimeline.waitTime}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Wait Time"
                                            maxLength="5"
                                            type="number"
                                            min="1"
                                            step="1"
                                            showError={this.state.waitTimeValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label className="required">Validity Time (in hours)</label>
                                        <FloatInput
                                            id="validTime"
                                            value={this.state.transactionTimeline.validTime}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Validity Time"
                                            maxLength="5"
                                            min="1"
                                            type="number"
                                            showError={this.state.validTimeValidity === 0} errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isDelete &&
                    <div className="mod-footer">

                        <div className="mod-footer-buttons">
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isView: false }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_TRANSACTION_TIMELINE]}>EDIT</CButton>
                            }
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isDelete: true }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.DELETE_TRANSACTION_TIMELINE]}>DELETE</CButton>

                            }

                            {!isView && isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.CREATE_TRANSACTION_TIMELINE]}>CREATE</CButton>

                            }
                            {!isView && !isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_TRANSACTION_TIMELINE]}>UPDATE</CButton>

                            }

                            <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>

                        </div>
                    </div>
                }
                {isDelete &&
                    <div className="mod-footer">
                        <div className="action-warning">
                            {Messages.ACTION_WARNING}  ?
                                </div>
                        <div className="mod-footer-buttons">
                            <button onClick={(evt) => { this.setState({ isDelete: false }) }} disabled={this.state.updating} className="btn btn-danger">NO</button>
                            <button onClick={(evt) => { this.handleDeleteAction(evt) }} disabled={this.state.updating} className="btn btn-primary">YES</button>

                        </div>
                    </div>
                }
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.disputeRegionValidity === 1 && this.state.disputeCategoryValidity === 1 && this.state.waitTimeValidity === 1 && this.state.validTimeValidity === 1;
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.disputeRegionValidity  && this.state.disputeCategoryValidity && this.state.waitTimeValidity && this.state.validTimeValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(TransactionTimelinesModal, [Permissions.VIEW_TRANSACTION_TIMELINE]));


// WEBPACK FOOTER //
// ./src/components/admin/transactionTimelines/transactionTimelinesModal.js